import { FONT_WEIGHT } from '../../foundations/typography';
import { TextVariantType } from '../text/variants';
export const parentContainerCommonStyles = (FOUNDATIONS, FONT) => ({
    display: 'flex',
    padding: FOUNDATIONS.spacing_250,
    border_radius: FOUNDATIONS.radius_comp_content_informativecard_radiussize,
});
export const parentContainerHorizontalCommonStyles = (FOUNDATIONS, FONT) => ({
    ...parentContainerCommonStyles(FOUNDATIONS, FONT),
    flex_direction: 'row',
    column_gap: FOUNDATIONS.spacing_150,
});
export const parentContainerVerticalCommonStyles = (FOUNDATIONS, FONT) => ({
    ...parentContainerCommonStyles(FOUNDATIONS, FONT),
    align_items: 'center',
    width: '9.75rem',
    flex_direction: 'column',
    row_gap: FOUNDATIONS.spacing_150,
    padding_top: FOUNDATIONS.spacing_300,
    padding_bottom: FOUNDATIONS.spacing_300,
});
export const iconCommonStyles = (FOUNDATIONS, FONT) => ({
    width: FOUNDATIONS.size_350,
    height: FOUNDATIONS.size_350,
});
export const labelCommonStyles = (FOUNDATIONS, FONT) => ({
    font_variant: TextVariantType.FONT_PARAGRAPH_200,
    font_weight: FONT_WEIGHT.font_regular,
    color: FOUNDATIONS.color_neutral_font_onsurface_200,
});
export const titleCommonStyles = (FOUNDATIONS, FONT) => ({
    font_variant: TextVariantType.FONT_TITLE_50,
    font_weight: FONT_WEIGHT.font_bold,
    color: FOUNDATIONS.color_neutral_font_onsurface_50,
});
export const descriptionCommonStyles = (FOUNDATIONS, FONT) => ({
    font_variant: TextVariantType.FONT_PARAGRAPH_350,
    font_weight: FONT_WEIGHT.font_regular,
    color: FOUNDATIONS.color_neutral_font_onsurface_50,
});
export const infoContainerVerticalCommonStyles = (FOUNDATIONS, FONT) => ({
    display: 'flex',
    flex_direction: 'column',
    align_items: 'center',
    width: '100%',
});
//# sourceMappingURL=commonStyles.js.map